export default {
    computed: {
        options() {
            //https://getdatepicker.com/4/Options/
            return {
                format: 'DD/MM/YYYY',
                maxDate: new Date(),
                locale: process.env.VUE_APP_DATE_LOCALE,
            }
        },
    },
}